import { Component, OnInit } from '@angular/core';
import {faFacebook,faTwitter,faPinterest,faLinkedin,faWordpress } from '@fortawesome/free-brands-svg-icons'
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  faFacebook=faFacebook;
  faTwitter=faTwitter;
  faPinterest=faPinterest;
  faLinkedin=faLinkedin;
  faWordpress =faWordpress;
  faNewspaper=faNewspaper;
  constructor() { }

  ngOnInit() {
  }

}
